import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import convertSecondsToTime from '../../../../../../helper/convertSecondsToTime';

@Component({
  selector: 'app-p00039-eclairage-status',
  templateUrl: './p00039-eclairage-status.component.html',
  styleUrls: ['./p00039-eclairage-status.component.scss'],
  imports: [
    DisplayRubriqueStatusOnOffComponent,
    TranslatePipe,
    DisplayRubriqueStatusComponent,
  ],
})
export class P00039EclairageStatusComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly convertSecondsToTime = convertSecondsToTime;
}
